import { ImageLoaderConfig } from '@angular/common';

/**
 * `IMAGE_LOADER` für Bilder aus einem der beiden Renderer-Manifeste (Autos, Strecken): beide legen
 * ihre Ausgaben als `<ansicht>.<hash>.<400|800|1600|hero>.webp` ab. Wählt aus der angefragten Breite
 * die passende Variante.
 *
 * Breiten über 1600 px liefern die hero-Datei — die existiert nicht für jede Ansicht, nur für die
 * jeweils eine, die als Kopfbild vorgesehen ist (Autos: `front`, Strecken: `startziel`). Fordert der
 * Aufrufer für eine Ansicht ohne hero-Datei trotzdem eine Breite über 1600 an, liefert der Loader
 * eine URL, die serverseitig nicht existiert — das ist Sache des Aufrufers (`ngSrcset`/`sizes` so zu
 * begrenzen, dass das nicht passiert), nicht dieser Funktion.
 *
 * Ursprünglich unter dem Namen `carImageLoader` nur in `features/cars` definiert; hierher gezogen,
 * damit `features/tracks` ihn mitbenutzen kann, ohne quer über ein fremdes Feature zu importieren.
 */
export function rendererImageLoader(config: ImageLoaderConfig): string {
    if (!config.width) return config.src;
    const variant = config.width <= 400 ? '400' : config.width <= 800 ? '800' : config.width <= 1600 ? '1600' : 'hero';
    return config.src.replace(/\.(400|800|1600|hero)\.webp$/, `.${variant}.webp`);
}
